// @flow

import * as DOMPurify from 'dompurify';
import React from 'react';
import ReactPlayer from 'react-player';
import { Link } from 'react-router-dom';

import { formatFullDate, getDateFromString } from 'utils/dateUtils';

export type StateProps = {
  data: any
};

type OwnProps = {
  goBack(): void
};

export type Props = StateProps & OwnProps;

export default function CompetitionInternationalesDefaultHeader({ data, goBack }: Props) {
  let title = data.title.raw;
  //let backgroundImage = 'url(/img/banner/xv.jpg)';
  const backgroundVideo =
    !!data && !!data.meta && !!data.meta.header_video_src
      ? data.meta.header_video_src
      : '/img/banner/bannervideov1720p.mp4';
  let hasRencontre = false;
  let rencontreEnCours =
    data.dernieres_rencontres &&
    data.dernieres_rencontres.length > 0 &&
    data.dernieres_rencontres.find(
      rencontre => rencontre.rencontre_live === true && rencontre.rencontre_terminee === false
    );
  let rencontreAVenir = false;
  if (!rencontreEnCours) {
    rencontreEnCours =
      data.prochaines_rencontres &&
      data.prochaines_rencontres.length > 0 &&
      data.prochaines_rencontres.find(
        rencontre => rencontre.rencontre_live === true && rencontre.rencontre_terminee === false
      );
  }

  if (data.featured_media.src) {
    //backgroundImage = `url(${data.featured_media.src})`;
  }

  // console.log(rencontreEnCours)
  if (data.meta.statut_competition === 'a_venir') {
    title = data.title.raw;
  } else if (data.meta.statut_competition === 'terminee') {
    title = 'Revivez vos moments favoris de l’équipe de<br/>France pendant';
    if (data.title.raw.match(/Coupe /) || data.title.raw.match(/coupe /)) {
      title = `${title} la ${data.title.raw}`;
    } else if (data.title.raw.match(/Tournoi /) || data.title.raw.match(/tournoi /)) {
      title = `${title} le ${data.title.raw}`;
    } else {
      title = `${title} les ${data.title.raw}`;
    }
  } else if (rencontreEnCours) {
    title = 'Match en direct';
    // console.log(rencontreEnCours[0]);
    const {
      reception,
      adversaire,
      date_rencontre,
      lieu,
      france_score,
      adversaire_score,
      competition_internationale_link
    } = rencontreEnCours;

    const dateRencontre = date_rencontre ? getDateFromString(date_rencontre) : null;

    const hasEventDrivenPageLink = competition_internationale_link.includes('/competitions-internationales');

    return (
      <section className="banner">
        {/* <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: backgroundImage }} /> */}

        <ReactPlayer className="banner__video__thumbnail" url={backgroundVideo} loop muted playsinline playing />

        <div className="banner__content">
          <div className="banner__content__return">
            <button onClick={goBack} className="go-back">
              <i className="icon icon-chevron-left is-inline" />
              <span>{'Retour'}</span>
            </button>
          </div>

          <div className="banner__content__title">
            <h1 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }} />
            <p className="next-match__teams mt-7">
              <span className="">{reception ? 'France' : adversaire}</span>
              <span className="live-match__teams-header__score__result">
                <span className="">{reception ? france_score : adversaire_score}</span>
                <span className=""> - </span>
                <span className="">{reception ? adversaire_score : france_score}</span>
              </span>
              <span>{reception ? adversaire : 'France'}</span>
            </p>
            <p className="next-match__date">
              {dateRencontre &&
                `${formatFullDate(dateRencontre)} à ${dateRencontre.getHours()}h${
                  dateRencontre.getMinutes() >= 10 ? dateRencontre.getMinutes() : '0' + dateRencontre.getMinutes()
                }`}
            </p>
            <p className="live-match__place">{lieu}</p>
            {hasEventDrivenPageLink && (
              <p>
                <Link to={competition_internationale_link} className={`btn btn-banner mt-3`}>
                  VOIR LE DIRECT
                </Link>
              </p>
            )}
          </div>
        </div>
      </section>
    );
  } else if (
    data.prochaines_rencontres &&
    data.prochaines_rencontres.length > 0 &&
    data.prochaines_rencontres.find(rencontre => rencontre.rencontre_terminee === false)
  ) {
    title = `Prochain match du ${data.meta.equipeNom}`;
    rencontreAVenir = data.prochaines_rencontres.find(rencontre => rencontre.rencontre_terminee === false);
    if (rencontreAVenir.featured_media && rencontreAVenir.featured_media.src) {
      //backgroundImage = `url(${rencontreAVenir.featured_media.src})`;
    }
    hasRencontre = true;
  }

  if (hasRencontre && rencontreAVenir) {
    const { reception, adversaire, date_rencontre, lieu } = rencontreAVenir;
    const dateRencontre = date_rencontre ? getDateFromString(date_rencontre) : null;
    return (
      <section className="banner">
        {/* <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: backgroundImage }} /> */}

        <ReactPlayer className="banner__video__thumbnail" url={backgroundVideo} loop muted playsinline playing />

        <div className="banner__content">
          <div className="banner__content__return">
            <button onClick={goBack} className="go-back">
              <i className="icon icon-chevron-left is-inline" />
              <span>{'Retour'}</span>
            </button>
          </div>

          <div className="banner__content__title">
            <h1 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }} />

            <p className="next-match__date mt-7">
              {dateRencontre &&
                `${formatFullDate(dateRencontre)} à ${dateRencontre.getHours()}h${
                  dateRencontre.getMinutes() >= 10 ? dateRencontre.getMinutes() : '0' + dateRencontre.getMinutes()
                }`}
            </p>
            <p className="next-match__teams">
              <span className="">{reception ? 'France' : adversaire}</span>
              <span className="next-match__teams__vs">{' VS '}</span>
              <span>{reception ? adversaire : 'France'}</span>
            </p>
            <p className="live-match__place">{lieu}</p>
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="banner">
      {/* <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: backgroundImage }} /> */}

      <ReactPlayer className="banner__video__thumbnail" url={backgroundVideo} loop muted playsinline playing />

      <div className="banner__content">
        <div className="banner__content__return">
          <button onClick={goBack} className="go-back">
            <i className="icon icon-chevron-left is-inline" />
            <span>{'Retour'}</span>
          </button>
        </div>

        <div className="banner__content__title">
          <h1 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }} />
          {data.meta.statut_competition !== 'terminee' && (
            <p>
              {data.meta.start_date && formatFullDate(getDateFromString(data.meta.start_date))}{' '}
              {data.meta.start_date && data.meta.end_date && ' - '}{' '}
              {data.meta.end_date && formatFullDate(getDateFromString(data.meta.end_date))}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
